import React from 'react';
import { IOldIconProps } from './type';

const ExclamationMark: React.FC<IOldIconProps> = ({
  color = '#FF573E',
  width,
  height,
  ...props
}) => {
  return (
    <svg
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16.5493C12.4183 16.5493 16 12.9675 16 8.54926C16 4.13098 12.4183 0.549255 8 0.549255C3.58172 0.549255 0 4.13098 0 8.54926C0 12.9675 3.58172 16.5493 8 16.5493ZM8.91229 10.4967L9.10618 3.36744H6.89382L7.09268 10.4967H8.91229ZM7.15732 13.3305C7.39264 13.5625 7.67436 13.6785 8.00249 13.6785C8.21461 13.6785 8.41016 13.6255 8.58913 13.5194C8.76811 13.4101 8.91229 13.2659 9.02166 13.0869C9.13435 12.9046 9.19235 12.7041 9.19567 12.4853C9.19235 12.1605 9.07138 11.8821 8.83274 11.6501C8.5941 11.4181 8.31735 11.3021 8.00249 11.3021C7.67436 11.3021 7.39264 11.4181 7.15732 11.6501C6.92199 11.8821 6.80599 12.1605 6.8093 12.4853C6.80599 12.8135 6.92199 13.0952 7.15732 13.3305Z"
        fill={color}
      />
    </svg>
  );
};

export default ExclamationMark;
